import axios from 'axios'

export default {
    store: (data) => axios.post('assets/documents/store', data, {headers: {"Content-Type": "multipart/form-data"}}),
    delete: (data) => axios.post('assets/documents/delete', data),
}